export const SCORE_MEANING = {
  low: "A low score suggests fewer ADHD symptoms. However, if you're struggling to focus or your relationships are affected, consider consulting a mental health professional.",
  high: "A high score may indicate ADHD symptoms, which can impact daily tasks and relationships. We strongly recommend consulting a mental health professional for a full evaluation.",
};

export const SCORE_RECOMMENDATION = {
  low: "Your results suggest a low likelihood of ADHD. However, this is a brief screening. If you're facing challenges in daily life, consider trying an ADHD self-care routine on Evolve and speaking to an expert.",
  high: "We strongly recommend trying Evolve's self-care routines for ADHD and getting a comprehensive assessment from a professional.",
};

export const ACTION_BTN_TXT = {
  low: "Begin your journey",
  high: "Begin your journey",
};
